import { z } from "zod";
// ============================================
// Core User Schema
// ============================================
export const UserSchema = z.object({
    id: z.string().optional(),
    user_email: z.string().email().optional(),
    user_phone_number: z.string().optional(),
    personal_info: z
        .object({
        first_name: z.string().optional(),
        last_name: z.string().optional(),
    })
        .optional(),
    is_admin: z.boolean().optional(),
});
// ============================================
// Encounter Core Schema (Shared across products)
// ============================================
export const EncounterCoreSchema = z.object({
    id: z.string(),
    patient_id: z.string(),
    clinician_id: z.string().optional(),
    date: z.string().datetime(), // ISO date string
    duration_seconds: z.number().optional(),
    status: z.enum(["pending", "processing", "completed", "failed"]).optional(),
    created_at: z.string().datetime().optional(),
    updated_at: z.string().datetime().optional(),
});
// ============================================
// VisitAssist-specific Encounter Facet
// ============================================
export const VisitAssistEncounterSchema = EncounterCoreSchema.extend({
    summary: z.string().optional(),
    transcript_url: z.string().url().optional(),
    audio_url: z.string().url().optional(),
    categories: z.array(z.string()).optional(),
    reminders: z
        .array(z.object({
        id: z.string(),
        text: z.string(),
        due_date: z.string().datetime().optional(),
        completed: z.boolean().default(false),
    }))
        .optional(),
});
// ============================================
// Inflect-specific Encounter Facet
// ============================================
export const InflectEncounterSchema = EncounterCoreSchema.extend({
    transcript: z
        .object({
        entries: z.array(z.object({
            speaker: z.enum(["clinician", "patient", "other"]),
            text: z.string(),
            start: z.number().optional(),
            end: z.number().optional(),
        })),
    })
        .optional(),
    feedback: z
        .object({
        score: z.number().min(0).max(100).optional(),
        metrics: z.record(z.number()).optional(),
    })
        .optional(),
    goals: z
        .array(z.object({
        id: z.string(),
        name: z.string(),
        target: z.number().optional(),
        current: z.number().optional(),
    }))
        .optional(),
});
// ============================================
// Legacy Visit Schema (for backward compatibility)
// ============================================
export const VisitSchema = z.object({
    id: z.string(),
    patient_id: z.string(),
    date: z.string().datetime(),
    summary: z.string().optional(),
});
